import { React, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLoading } from "./LoadingContext";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { Helmet } from "react-helmet-async";

function LoginPage() {
  const navigate = useNavigate();
  const { loading, setLoading } = useLoading();
  const [error] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(event.target);
      const email = formData.get("email");
      const password = formData.get("password");

      // Extract client name from subdomain
      const clientName = window.location.hostname.split(".")[0]; // Extract 'client1' from 'client1.localhost'

      if (!clientName) {
        throw new Error("Client name is missing from the URL");
      }

      // Fetch client ID from API using client name
      const clientIdResponse = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/get-client-id?client_name=${clientName}`
      );
      const clientId = clientIdResponse.data.client_id;

      if (!clientId) {
        throw new Error("Client ID not found for the given client name");
      }

      // Login API call
      const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/login/`;
      const headers = { "Content-Type": "application/json" };

      const data = { email, password, client: clientId };

      const response = await axios.post(apiEndpoint, data, { headers });

      const { user_type, name, token, user_id } = response.data.data;

      // **Ensure `client` is stored correctly**
      localStorage.setItem("user_type", user_type.toLowerCase());
      localStorage.setItem("name", name);
      localStorage.setItem("token", token);
      localStorage.setItem("client", clientId.toString()); // Convert to string for storage
      localStorage.setItem("user_id", user_id.toString());

      // console.log(
      //   "Client ID stored in localStorage:",
      //   localStorage.getItem("client")
      // );

      navigate("/selection_page");
      setLoading(false);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Client not found");
      setLoading(false);
      navigate("/login");
    }
  };

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Logging in...</h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <NavbarForOnboardingForm />
      <div className="container py-4 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-5 col-xl-4">
            <div
              className="card shadow-lg"
              style={{ borderRadius: "20px", overflow: "hidden" }}
            >
              {/* Card Header */}
              <div
                className="card-header text-white text-center"
                style={{
                  background: "#008cba",
                }}
              >
                <h3 className="fw-bold mb-0">LOGIN</h3>
              </div>

              {/* Card Body */}
              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                  {/* Email Field */}
                  <div className="mb-2 position-relative">
                    <label htmlFor="email" className="form-label fw-semibold">
                      Email Address
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-dark">
                        <i className="fas fa-envelope text-info"></i>
                      </span>
                      <input
                        type="email"
                        className="form-control border-dark shadow-sm"
                        id="email"
                        aria-describedby="emailHelp"
                        name="email"
                        placeholder="Enter your email"
                        required
                      />
                    </div>
                  </div>

                  {/* Password Field */}
                  <div className="mb-2 position-relative">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                    >
                      Password
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-dark">
                        <i className="fas fa-lock text-info"></i>
                      </span>
                      <input
                        type="password"
                        className="form-control border-dark shadow-sm"
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                        required
                      />
                    </div>
                  </div>

                  {/* Forgot Password Link */}
                  <div className="mb-2 text-end">
                    <Link to="/forgot_password" className="text-info small">
                      Forgot Password?
                    </Link>
                  </div>

                  {/* Login Button */}
                  <div className="d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-outline-info fw-bold  py-2 shadow-sm"
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>

              {/* Card Footer */}
              <div
                className="card-footer text-center text-muted small"
                style={{
                  background: "rgba(0, 0, 0, 0.05)",
                  borderTop: "1px solid #ddd",
                }}
              >
                <p className="mb-0">
                  Don't have an account?{" "}
                  <Link to="/signup" className="text-info fw-semibold">
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
